import apiClient from './apiClient';

export const getProfileErrorMessage = (error, fallbackMessage) => {
  const responseData = error.response?.data;
  const message = responseData?.msg
    || responseData?.message
    || responseData?.error
    || (typeof responseData === 'string' ? responseData : error.message);
  return message || fallbackMessage;
};

export const requestProfileOtp = async (mobile) => {
  const response = await apiClient.post('/api/v2/trust/user/send-otp', { mobile });
  if (response.data?.status === false) {
    throw new Error(
      response.data?.msg
      || response.data?.message
      || response.data?.error
      || 'Unable to send OTP. Please try again.'
    );
  }
  return response.data;
};

export const verifyOtpAndEnsureProfile = async (mobile, otp, { email, name }) => {
  if (!email) {
    throw new Error('Your logged-in email could not be found. Please log in again.');
  }
  const verifyResponse = await apiClient.post('/api/v2/trust/user/verify-otp', { mobile, otp });
  if (verifyResponse.data?.status === false) {
    throw new Error(
      verifyResponse.data?.msg
      || verifyResponse.data?.message
      || verifyResponse.data?.error
      || 'OTP verification failed.'
    );
  }
  const profileResponse = await apiClient.post('/api/v2/trust/user/profile', {
    mobile,
    email,
    name: name || email,
  });
  if (profileResponse.data?.status === false) {
    throw new Error(
      profileResponse.data?.msg
      || profileResponse.data?.message
      || profileResponse.data?.error
      || 'Unable to save your TrustApp profile. Please try again.'
    );
  }
  return profileResponse.data;
};
